import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, API, fmtDDMMYYYY } from "../../api";
import { PageHeader, Panel, Btn, Input, Select, Empty, Pill } from "../../ui";

export default function TasksPage() {
  const [list, setList] = useState(null);
  const [staff, setStaff] = useState([]);
  const [apps, setApps] = useState([]);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ case_id: "", title: "", owner_user_id: "", due_date: "" });
  const load = async () => {
    const [t, s, a] = await Promise.all([
      api.get(`${API}/tasks`),
      api.get(`${API}/users`),
      api.get(`${API}/applications`),
    ]);
    setList(t.data); setStaff(s.data.filter((u) => u.role !== "customer" && u.role !== "broker")); setApps(a.data);
  };
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post(`${API}/tasks`, f);
      toast.success("Task created"); setShow(false);
      setF({ case_id: "", title: "", owner_user_id: "", due_date: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not save"); }
  };
  const done = async (id) => { await api.put(`${API}/tasks/${id}/done`); toast.success("Done"); load(); };
  return (
    <div>
      <PageHeader title="Tasks & Follow-ups" subtitle="Every active case must have a next action, owner and follow-up date." action={<Btn onClick={() => setShow(true)}>+ New task</Btn>} />
      {show && (
        <Panel className="p-6 mb-6">
          <form onSubmit={create} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Select label="Case" required value={f.case_id} onChange={(e) => setF({ ...f, case_id: e.target.value })}><option value="">— pick —</option>{apps.map(a => <option key={a.id} value={a.id}>{a.ref}</option>)}</Select>
            <Input label="Title" required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} />
            <Select label="Owner" required value={f.owner_user_id} onChange={(e) => setF({ ...f, owner_user_id: e.target.value })}><option value="">— pick —</option>{staff.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}</Select>
            <Input label="Due date" type="date" required value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} />
            <div className="sm:col-span-2 flex justify-end gap-2"><Btn variant="ghost" type="button" onClick={() => setShow(false)}>Cancel</Btn><Btn type="submit">Save</Btn></div>
          </form>
        </Panel>
      )}
      {list === null ? <p className="text-sm text-slate-500">Loading…</p> : list.length === 0 ? <Empty title="No open tasks" /> : (
        <Panel>
          <ul className="divide-y divide-slate-100">
            {list.map((t) => <li key={t.id} className="px-5 py-3 flex items-center justify-between"><div><p className="text-sm font-medium">{t.title}</p><p className="text-[11px] text-slate-500">Due {fmtDDMMYYYY(t.due_date)}</p></div><button className="text-[11px] font-bold tracking-[0.14em] uppercase text-emerald-700 hover:underline" onClick={() => done(t.id)}>Mark done</button></li>)}
          </ul>
        </Panel>
      )}
    </div>
  );
}
